import { getYearMonth } from "./Calculators/Swp";

function sipFormula(amount: number, annualinc: number, returns: number, duration: number): number {
    var period = duration * 12;
    var totalsub = (1 + (returns / 1200));
    var sum = 0;
    for (var i = 1; i <= period; i++) {
        var installmentAmount = amount + Math.floor(1.0 * (i - 1) / 12) * annualinc;
        sum += installmentAmount * (Math.pow(totalsub, (period - i + 1)));
    }
    return sum;
}

export function lumpsumFormula(amount: number, returns: number, period: number): number {
    var totalsub = (1 + (returns / 100));
    var sum = (amount * Math.pow(totalsub, period));
    return sum;
}

function getLumpsumAmount(amount: number, returns: number, period: number): number {
    var totalsub = (1 + (returns / 100));
    var sum = (amount / Math.pow(totalsub, period));
    return sum;
}

export function getSipAmountFormula(investmentValue: number, returns: number, duration: number): number {

    var period = duration * 12
    var totalsub = (1 + (returns / 1200));
    var sum = 0;
    var sipAmount = 0;

    for (var i = 1; i <= period; i++) {
        sum += (Math.pow(totalsub, (period - i + 1)));
    }

    sipAmount = Math.ceil(investmentValue / sum);
    if (sum == 0) {
        sipAmount = 0
    }
    return sipAmount;
}
function sip(investmentAmount: number, duration: number, rate: number) {
    let data: { maturityValue: number, totalInvestedAmount: number, gain: number, time: number }[] = [];
    for (let j = 1; j <= duration; j++) {
        var maturityValue = sipFormula(investmentAmount, 0, rate, j);
        let sum = 0;
        for (let i = 1; i <= (j * 12); i++) {
            let installmentAmount = investmentAmount
            sum += installmentAmount;
        }
        var totalInvestedAmount = sum;
        var gain = maturityValue - totalInvestedAmount;
        data.push({ maturityValue: maturityValue, totalInvestedAmount: totalInvestedAmount, gain: gain, time: j });
    }
    return data
}

export function maturityAmount(interest: number, investmentPeriod: number, amount: number, selectedPeriod: string) {
    let rate = selectedPeriod == 'Monthly' ? (interest / 12) / 100 : interest / 100;
    let totalTime = selectedPeriod == 'Monthly' ? investmentPeriod * 12 : investmentPeriod;
    let totalAmount = amount * ((Math.pow((1 + rate), totalTime) - 1) * (1 + rate) / rate)
    return totalAmount
}
export const taxSaved = (amount: number, investmentPeriod: number, selectedPeriod: string) => {
    let taxSlabPercentage = 30;
    let taxSaved80C = 0;
    let taxSaved80CCD = 0;
    let principalAmt = selectedPeriod == 'Monthly' ? amount * 12 : amount;
    let yearlySaving = principalAmt > 150000 ? 150000 : principalAmt;
    taxSaved80C = yearlySaving * (taxSlabPercentage / 100) * investmentPeriod;

    if (principalAmt > 150000) {
        if ((principalAmt - 150000) > 50000) {
            taxSaved80CCD = 50000 * (taxSlabPercentage / 100) * investmentPeriod;
        } else {
            taxSaved80CCD = (principalAmt - 150000) * (taxSlabPercentage / 100) * investmentPeriod;
        }
    }

    return {
        totalTaxSaved: taxSaved80C + taxSaved80CCD,
        taxSaved80C,
        taxSaved80CCD
    }
}
export default class {

    static crorepatiCalculation(inputs: any) {
        let data: { [key: string]: string | number } = {};
        let investmentPeriod = parseFloat(inputs.targetAge) - parseFloat(inputs.currentAge);
        data.targetInflatedAmount = lumpsumFormula(parseFloat(inputs.targetAmount), parseFloat(inputs.inflationRate), investmentPeriod);
        data.growthSavingsAmount = lumpsumFormula(parseFloat(inputs.currentSavingsAmount), parseFloat(inputs.sipReturnsRate), investmentPeriod);
        data.requiredTargetAmount = data.targetInflatedAmount - data.growthSavingsAmount;
        data.requiredSipAmount = getSipAmountFormula(data.requiredTargetAmount, parseFloat(inputs.sipReturnsRate), investmentPeriod);
        data.investedSipAmount = data.requiredSipAmount * investmentPeriod * 12;
        data.totalGrowthAmount = data.requiredTargetAmount - data.investedSipAmount;
        return data;
    }

    static sipInstallments(inputs: any) {
        let data: { [key: string]: string | number } = {};
        let investmentPeriod = parseFloat(inputs.investmentPeriod);
        data.targetInflatedAmount = lumpsumFormula(parseFloat(inputs.targetAmount), parseFloat(inputs.inflationRate), investmentPeriod);
        data.growthSavingsAmount = lumpsumFormula(parseFloat(inputs.currentSavingsAmount), parseFloat(inputs.sipReturnsRate), investmentPeriod);
        data.requiredTargetAmount = data.targetInflatedAmount - data.growthSavingsAmount;
        data.requiredSipAmount = getSipAmountFormula(data.requiredTargetAmount, parseFloat(inputs.sipReturnsRate), investmentPeriod);
        data.investedSipAmount = data.requiredSipAmount * investmentPeriod * 12;
        data.totalGrowthAmount = data.requiredTargetAmount - data.investedSipAmount;
        return data;
    }

    // networthCalculator(inputs) {
    //     let data = {};
    //     Object.assign(data, inputs);
    //     data.totalAssets = data.sharesAmount + data.fixedIncomeAssetsAmount + data.bankAmount + data.propertyAmount + data.commoditiesAmount;
    //     data.totalLiabilities = data.homeLoanAmount + data.otherLoanAmount + data.taxOwedAmount + data.outstandingAmount + data.creditCardAmount + data.otherLiabilitiesAmount;
    //     data.networth = data.totalAssets - data.totalLiabilities;
    //     return data;
    // }

    //   Education Calculator
    static educationPlanner(inputs: any) {
        let data: { [key: string]: number } = {};
        let differenceAge = (parseFloat(inputs.targetAge) - parseFloat(inputs.currentAge));
        data.requiredInflatedAmount = lumpsumFormula(parseFloat(inputs.requiredAmount), parseFloat(inputs.inflationRate), differenceAge);
        data.requiredAmount = parseFloat(inputs.requiredAmount);
        data.currentSavingsAmount = lumpsumFormula(parseFloat(inputs.currentSavingsAmount), parseFloat(inputs.expectedReturns), differenceAge);
        data.additionalSavings = data.requiredInflatedAmount - data.currentSavingsAmount;
        data.monthlySip = getSipAmountFormula(data.additionalSavings, parseFloat(inputs.expectedReturns), differenceAge)
        if (inputs.requiredAmount < 100 || inputs.currentAge < 0 || inputs.targetAge < 16 || inputs.expectedReturns < 1) {
            data.requiredInflatedAmount = 0
            data.requiredAmount = 0;
            data.currentSavingsAmount = 0;
            data.additionalSavings = 0;
            data.monthlySip = 0;
        }
        return data;
    }

    // Retirement Calculator
    static retirementCalculator(inputs: any) {
        let data: { [key: string]: number } = {};
        let ageDiff = (parseFloat(inputs.targetAge) - parseFloat(inputs.currentAge));
        let monthlyExpenses = parseFloat(inputs.targetAmount) * (Math.pow(1 + (parseFloat(inputs.inflationRate) / 100), ageDiff));
        let retirementAmountCompounded = lumpsumFormula(parseFloat(inputs.currentSavingsAmount), parseFloat(inputs.expectedReturns), ageDiff);
        data.retirementAmount = monthlyExpenses * 12 * ((parseFloat(inputs.lifeExpectancy) - parseFloat(inputs.targetAge)));
        data.sipAmount = getSipAmountFormula((data.retirementAmount - retirementAmountCompounded), parseFloat(inputs.expectedReturns), ageDiff);
        data.additionalSavings = data.retirementAmount - retirementAmountCompounded;
        data.retirementAmountCompounded = retirementAmountCompounded;

        if (inputs.targetAmount < 100 || inputs.currentAge < 18 || inputs.targetAge < 40 || inputs.lifeExpectancy < 80 || inputs.expectedReturns < 1) {
            data.retirementAmount = 0;
            data.sipAmount = 0;
            data.additionalSavings = 0;
            data.retirementAmountCompounded = 0;
        }
        return data;
    }

    // SIP return calculator
    static sipReturnsCalculation(inputs: any) {
        let data: { maturityValue: number, totalInvestedAmount: number, gain: number, time: number }[] = [];
        var duration = parseFloat(inputs.investmentPeriod);
        var investmentAmount = parseFloat(inputs.investmentAmount);
        var rate = parseFloat(inputs.returnsRate);
        var annualInc = parseFloat(inputs.annualIncrement)

        for (let j = 1; j <= duration; j++) {
            var maturityValue = sipFormula(investmentAmount, annualInc, rate, j);
            let sum = 0;
            for (let i = 1; i <= (j * 12); i++) {
                let installmentAmount = investmentAmount + Math.floor(1.0 * (i - 1) / 12) * annualInc;
                sum += installmentAmount;
            }
            var totalInvestedAmount = sum;
            var gain = maturityValue - totalInvestedAmount;
            data.push({ maturityValue: maturityValue, totalInvestedAmount: totalInvestedAmount, gain: gain, time: j });
        }
        if (inputs.investmentAmount < 100 || inputs.investmentPeriod < 1 || inputs.returnsRate < 1) {
            data.push({ maturityValue: 0, totalInvestedAmount: 0, gain: 0, time: 0, })
        }
        return data;
    }


    static goalCalculatorSip(inputs: any) {
        let inflatedAmount = lumpsumFormula(parseFloat(inputs.requiredAmount), parseFloat(inputs.inflationRate), parseFloat(inputs.investmentPeriod));
        let monthlySavingsAmount = getSipAmountFormula(inflatedAmount, parseFloat(inputs.sipReturnsRate), parseFloat(inputs.investmentPeriod));
        var ans = sip(monthlySavingsAmount, parseFloat(inputs.investmentPeriod), parseFloat(inputs.sipReturnsRate));
        if (inputs.requiredAmount < 1000 || inputs.inflationRate < 1 || inputs.investmentPeriod < 1 || inputs.sipReturnsRate < 1) {
            // todo make output 0
        }
        return ans;
    }

    //   Goal Calculator
    static goalCalculatorLumpsum(inputs: any) {
        let data: { [key: string]: number } = {};
        // if (inputs.investmentType == "Lumpsum") {
        data.inflatedAmount = lumpsumFormula(parseFloat(inputs.requiredAmount), parseFloat(inputs.inflationRate), parseFloat(inputs.investmentPeriod));
        data.lumpsumRequired = (data.inflatedAmount) / ((1 + inputs.sipReturnsRate / 100) ** (inputs.investmentPeriod))
        data.gains = (data.inflatedAmount - data.lumpsumRequired)
        if (inputs.requiredAmount < 100 || inputs.investmentPeriod < 1 || inputs.sipReturnsRate < 1) {
            data.inflatedAmount = 0;
            data.lumpsumRequired = 0;
            data.gains = 0;
        }
        return data;
    }

    ppfCalculator(inputs: any) {
        let data: { [key: string]: string | number } = {};
        let tableBody = [];
        let numberOfYears = 0;
        let openingBalance = 0;
        let closingBalance = 0;
        let totalInvestment = 0;
        let closingBalanceArr: number[] = []

        let withdrawalLimit = function (i: number) {
            if (i > 5)
                return Math.round(closingBalanceArr[i - 3] / 2);
            return "-"
        }

        let loan = function (i: number) {
            if (i > 1)
                return Math.round(closingBalanceArr[i - 2] / 4);
            return "-"
        }

        if (2019 - parseFloat(inputs.dateOfInvestment) >= 15)
            numberOfYears = 14;
        else
            numberOfYears = 2019 - parseFloat(inputs.dateOfInvestment);

        let tableHeaders = [
            "Year",
            "Interest Rate",
            "Opening Balance",
            "Annual Investment",
            "Total Investment",
            "Interest",
            "Closing Balance",
            "Premature Withdrawal",
            "Loan Possible"
        ];

        // formula correct only need to correct interest rate structure

        for (let i = 0; i <= numberOfYears; i++) {
            openingBalance = closingBalance;
            totalInvestment = openingBalance + parseFloat(inputs.investmentAmount);
            let interest = Math.round(totalInvestment * ppfReturnsRate[`${parseFloat(inputs.dateOfInvestment) + i}`] / 100);
            closingBalance = totalInvestment + interest;
            closingBalanceArr.push(closingBalance);

            tableBody.push([
                parseFloat(inputs.investmentAmount) + i,
                ppfReturnsRate[`${parseFloat(inputs.dateOfInvestment) + i}`],
                openingBalance,
                data.investmentAmount,
                totalInvestment,
                interest,
                closingBalance,
                withdrawalLimit(i),
                loan(i)
            ]);
        }
        return data;
    }

    // etfCalculator(inputs) {
    //     let data = {};
    //     Object.assign(data, inputs);

    //     data.tableHeaders = [
    //         "Age",
    //         "Opening EPF Balance",
    //         "Employee contribution",
    //         "Employer contribution",
    //         "Closing EPF Balance",
    //         "Diverted to Pension Fund",
    //     ];

    //     let openingBalance = data.etfBalance;
    //     let openingPensionBalance = data.currentPensionFund

    //     for (let i = data.currentAge; i <= data.targetAge; i++) {
    //         openingBalance = closingBalance;
    //         totalInvestment = openingBalance + data.investmentAmount;
    //         let interest = Math.round(totalInvestment * ppfReturnsRate[data.dateOfInvestment + i] / 100);
    //         closingBalance = totalInvestment + interest;
    //         closingBalanceArr.push(closingBalance);

    //         data.tableBody.push([
    //             data.dateOfInvestment + i,
    //             ppfReturnsRate[data.dateOfInvestment + i],
    //             openingBalance,
    //             data.investmentAmount,
    //             totalInvestment,
    //             interest,
    //             closingBalance,
    //             withdrawalLimit(i),
    //             loan(i)
    //         ]);
    //     }

    //     return data;
    // }


    // Lumpsum Calculator
    static lumpsumCalculation(inputs: any) {
        let data: { maturity: number, gain: number, time: number, amount: number }[] = [];
        var duration = parseFloat(inputs.investmentPeriod);
        var amount = parseFloat(inputs.investedAmount);
        var rate = parseFloat(inputs.inflationRate);
        for (var i = 1; i <= duration; i++) {
            var maturityAmount = lumpsumFormula(amount, rate, i);
            var gains = maturityAmount - amount;
            var time = i;
            data.push({ maturity: maturityAmount, gain: gains, time: time, amount: amount });
        }
        if (inputs.investedAmount < 100 || inputs.investmentPeriod < 1 || inputs.inflationRate < 1) {
            data.push({ maturity: 0, gain: 0, time: 0, amount: 0 })
        }
        return data;
    }


    // Inflation Calculator
    static inflationCalculation(inputs: any) {
        let data: { [key: string]: number } = {};
        data.targetAmount = lumpsumFormula(parseFloat(inputs.currentAmount), parseFloat(inputs.inflationRate), parseFloat(inputs.investmentPeriod));
        data.growthAmount = (data.targetAmount - parseFloat(inputs.currentAmount));
        data.totalInvestedAmount = parseFloat(inputs.currentAmount)
        if (inputs.currentAmount < 100 || inputs.investmentPeriod < 1 || inputs.inflationRate < 1) {
            data.targetAmount = 0;
            data.growthAmount = 0;
            data.totalInvestedAmount = 0;
        }
        return data;
    }

    // Emi Calculator
    static emiCalculation(inputs: any) {
        let data: { [key: string]: number } = {};
        let rate = parseFloat(inputs.interestRate) / 1200;
        let tenure = parseFloat(inputs.loanPeriod) * 12;
        data.monthlyAmount = parseFloat(inputs.loanAmount) * rate * (Math.pow((1 + rate), tenure) / (Math.pow((1 + rate), tenure) - 1));
        data.totalAmount = data.monthlyAmount * tenure;
        data.interestAmount = data.totalAmount - parseFloat(inputs.loanAmount);
        data.loanAmount = parseFloat(inputs.loanAmount);
        if (inputs.loanAmount < 100 || inputs.interestRate < 1 || inputs.loanPeriod < 1) {
            data.monthlyAmount = 0;
            data.totalAmount = 0;
            data.interestAmount = 0;
            data.loanAmount = 0;
        }
        return data;
    }


    // Compound Interest Calculator
    static compoundCalculation(inputs: any) {
        let data: { [key: string]: number } = {};
        let n: number;
        let r: number;
        if (inputs.interval === "Quarterly") {
            n = 4;
            r = parseFloat(inputs.interestRate) / 100 / n;
        } else if (inputs.interval === "Monthly") {
            n = 12;
            r = parseFloat(inputs.interestRate) / 100 / n;
        } else if (inputs.interval === "Half-Yearly") {
            n = 2;
            r = parseFloat(inputs.interestRate) / 100 / n;
        } else {
            n = 1;
            r = parseFloat(inputs.interestRate) / 100;
        }

        data.principalAmount = parseFloat(inputs.principalAmount);
        data.maturityAmount = parseFloat(inputs.principalAmount) * Math.pow(1 + r, n * parseFloat(inputs.investmentPeriod))
        if (inputs.principalAmount < 100 || inputs.investmentPeriod < 1 || inputs.interestRate < 1) {
            data.principalAmount = 0;
            data.maturityAmount = 0;
        }
        return data
    }

    static npsCalculation(inputs: { amount: number, interest: number, tenure: number }) {
        return sipFormula(inputs.amount, 0, inputs.interest, inputs.tenure)
    }

    // Swp calculator
    static swpCalculator(inputs: any) {
        let data: { maturityAmountPerMonth: number, time: number, depleteTime?: number, isContinuousIncreasing?: boolean }[] = [];
        var totalInvestment = inputs.totalInvestment;
        var withDrawalPerMonth = inputs.withdrawalPerMonth;
        var rate = inputs.expectedReturns;
        var duration = inputs.withdrawalPeriod;
        var waitingPeriodBeforeWithdrawal = inputs.waitingPeriodBeforeWithdrawal
        var withdrawalIncreaseRate = inputs.withdrawalIncreaseRate;
        var leftBalance: number = 0;
        let minPositiveValue = Number.POSITIVE_INFINITY;
        let minPositiveValueTime = 0;

        var prev: number = 0;
        var isContinuousIncreasing: boolean = true;

        var withdrawalAmount: number = withDrawalPerMonth;

        for (var j = 1; j <= waitingPeriodBeforeWithdrawal; j++) {
            var initialValue = totalInvestment;
            var maturityAmountPerMonth: number = (j == 1 ? initialValue : leftBalance) * (1 + rate / (100));
            leftBalance = maturityAmountPerMonth;
        }
        totalInvestment = leftBalance === 0 ? totalInvestment : leftBalance;

        // If maturityAmount is continuously increasing
        for (var j = 1; j <= (duration) * 12; j++) {
            initialValue = totalInvestment - withdrawalAmount;
            var maturityAmountPerMonth: number = (j == 1 ? initialValue : leftBalance) * (1 + rate / (100 * 12));
            if ((j) % 12 === 0 && withdrawalIncreaseRate !== 0 && withdrawalIncreaseRate) {
                withdrawalAmount += withdrawalAmount * (withdrawalIncreaseRate / 100);
            }
            leftBalance = (maturityAmountPerMonth - withdrawalAmount);

            if (j > 1) {
                if (maturityAmountPerMonth < prev && maturityAmountPerMonth < totalInvestment) {
                    isContinuousIncreasing = false;
                    break;
                }
            }
            prev = maturityAmountPerMonth;
        }

        // if maturityAmount is not increasing then find minimum positive value
        var sum = 0;
        withdrawalAmount = withDrawalPerMonth;
        if (!isContinuousIncreasing) {
            for (var j = 1; j <= (duration) * 12; j++) {
                initialValue = (totalInvestment - withDrawalPerMonth);
                var maturityAmountPerMonth: number = (j == 1 ? initialValue : leftBalance) * (1 + rate / (100 * 12));

                if ((j) % 12 === 0 && withdrawalIncreaseRate !== 0 && withdrawalIncreaseRate) {
                    withdrawalAmount += withdrawalAmount * (withdrawalIncreaseRate / 100);
                }

                leftBalance = (maturityAmountPerMonth - withdrawalAmount);

                if (maturityAmountPerMonth >= 0 && maturityAmountPerMonth < minPositiveValue) {
                    minPositiveValue = maturityAmountPerMonth;
                    minPositiveValueTime = j;
                }
            }
            if (minPositiveValueTime == Number.POSITIVE_INFINITY || minPositiveValue == Number.POSITIVE_INFINITY) {
                minPositiveValueTime = 0;
                minPositiveValue = 0;
            }
        }
        sum = 0;
        withdrawalAmount = withDrawalPerMonth;
        if (totalInvestment >= 100 && withDrawalPerMonth >= 100 && rate >= 1 && duration >= 1) {
            for (var j = 1; j <= (duration) * 12; j++) {
                initialValue = (totalInvestment - withDrawalPerMonth);
                var principalAmount = (j == 1 ? initialValue : leftBalance);
                var maturityAmountPerMonth: number = principalAmount * (1 + rate / (100 * 12));
                if ((j) % 12 === 0 && withdrawalIncreaseRate !== 0 && withdrawalIncreaseRate) {
                    withdrawalAmount += withdrawalAmount * (withdrawalIncreaseRate / 100);
                }

                leftBalance = (maturityAmountPerMonth - withdrawalAmount);

                if (!isContinuousIncreasing) {
                    if (minPositiveValueTime >= 24) {
                        if (j % 12 == 0) {
                            var year = j / 12;
                            data.push({ maturityAmountPerMonth: maturityAmountPerMonth, time: year, depleteTime: minPositiveValueTime, isContinuousIncreasing: false });
                        }

                    } else {
                        data.push({ maturityAmountPerMonth: maturityAmountPerMonth, time: j, depleteTime: minPositiveValueTime, isContinuousIncreasing: false });
                    }
                } else {
                    if (duration * 12 >= 24) {
                        if (j % 12 == 0) {
                            var year = j / 12;
                            data.push({ maturityAmountPerMonth: maturityAmountPerMonth, time: year, isContinuousIncreasing: true });
                        }
                    } else {

                        data.push({ maturityAmountPerMonth: maturityAmountPerMonth, time: j, isContinuousIncreasing: true });
                    }
                }
            }
        } else {

            data.push({ maturityAmountPerMonth: 0, time: 0, isContinuousIncreasing: false, depleteTime: 0 })
        }

        return data;
    }

    static regularIncomeCalculationForYears({ sipAmount, lumpsumAmount, investmentPeriod, expectedReturnRate, waitingPeriodBeforeWithdrawal, withdrawalYears, monthlyWithdrawal, expectedReturnValue, }:
        { sipAmount: number, lumpsumAmount: number, investmentPeriod: number, expectedReturnRate: number, waitingPeriodBeforeWithdrawal: number, withdrawalYears: number, monthlyWithdrawal: number, expectedReturnValue: number, }) {
        let data: { portfolioValue: number, time: number }[] = [];
        if ((investmentPeriod + waitingPeriodBeforeWithdrawal + withdrawalYears) <= 2) {
            let months: number = (investmentPeriod + waitingPeriodBeforeWithdrawal) * 12;
            data = this.monthlyInvestmentPortfolioCalculation({
                months,
                expectedReturnRate,
                sipAmount: sipAmount,
                lumpsumAmount
            })
            var withdrawalInput = {
                totalInvestment: data[data.length - 1].portfolioValue,
                withdrawalPerMonth: monthlyWithdrawal,
                expectedReturns: expectedReturnValue,
                withdrawalPeriod: withdrawalYears
            }
            var out: {
                maturityAmountPerMonth: number;
                time: number;
                depleteTime?: number | undefined;
                isContinuousIncreasing?: boolean | undefined;
            }[] = this.swpCalculator(withdrawalInput)
            var positiveMaturityAmount = out.map((item,) => {
                if (item.maturityAmountPerMonth > 0) {
                    return {
                        maturityAmountPerMonth: item.maturityAmountPerMonth,
                        time: item.time,
                        depleteTime: item.depleteTime,
                        isContinuousIncreasing: item.isContinuousIncreasing
                    }
                }
            }).filter(Boolean);
            //  For showing the bar of total Investment on X axis for x=0
            positiveMaturityAmount.unshift({
                maturityAmountPerMonth: data[data.length - 1].portfolioValue,
                time: 0,
                depleteTime: 0,
                isContinuousIncreasing: undefined
            });
            for (let i = 1; i < positiveMaturityAmount.length; i++) {
                data.push({
                    portfolioValue: positiveMaturityAmount[i]?.maturityAmountPerMonth ?? 0, time:
                        positiveMaturityAmount[i]?.time != undefined ? data.length + 1 : 0,
                });
            }

        } else {
            if (investmentPeriod + waitingPeriodBeforeWithdrawal > 1 && withdrawalYears === 1) {
                data = this.portfolioAndWaitingPeriodBeforeWithdrawalCalculation({
                    investmentPeriod,
                    sipAmount,
                    expectedReturnRate,
                    lumpsumAmount,
                    waitingPeriodBeforeWithdrawal

                })

                data.push({
                    portfolioValue: 0, time:
                        data.length + 1,
                });

            } else {
                data = this.portfolioAndWaitingPeriodBeforeWithdrawalCalculation({
                    investmentPeriod,
                    sipAmount,
                    expectedReturnRate,
                    lumpsumAmount,
                    waitingPeriodBeforeWithdrawal
                })

                //withdrawal period
                var withdrawalInput = {
                    totalInvestment: data[data.length - 1].portfolioValue,
                    withdrawalPerMonth: monthlyWithdrawal,
                    expectedReturns: expectedReturnValue,
                    withdrawalPeriod: withdrawalYears
                }
                var out: {
                    maturityAmountPerMonth: number;
                    time: number;
                    depleteTime?: number | undefined;
                    isContinuousIncreasing?: boolean | undefined;
                }[] = this.swpCalculator(withdrawalInput)

                var positiveMaturityAmount = out.map((item, index) => {
                    if (item.maturityAmountPerMonth > 0) {
                        return {
                            maturityAmountPerMonth: item.maturityAmountPerMonth,
                            time: item.time,
                            depleteTime: item.depleteTime,
                            isContinuousIncreasing: item.isContinuousIncreasing
                        }
                    }
                }).filter(Boolean);
                //  For showing the bar of total Investment on X axis for x=0
                positiveMaturityAmount.unshift({
                    maturityAmountPerMonth: data[data.length - 1].portfolioValue,
                    time: 0,
                    depleteTime: 0,
                    isContinuousIncreasing: undefined
                });
                //no of years
                for (let i = 1; i < positiveMaturityAmount.length; i++) {
                    data.push({
                        portfolioValue: positiveMaturityAmount[i]?.maturityAmountPerMonth ?? 0, time:
                            positiveMaturityAmount[i]?.time != undefined ? data.length + 1 : 0,
                    });
                }
            }

        }

        return data;
    }

    static monthlyInvestmentPortfolioCalculation({ months, expectedReturnRate, sipAmount, lumpsumAmount }: { months: number, expectedReturnRate: number, sipAmount: number, lumpsumAmount: number }) {
        let portfolioValue = 0;
        let portfolioInvestment = lumpsumAmount;
        let data: { portfolioValue: number, time: number }[] = [];
        for (let i = 1; i <= months; i++) {
            let lumpsumPortfolio = portfolioInvestment * (1 + expectedReturnRate / 1200);
            let sipContribution = sipAmount * (1 + expectedReturnRate / 1200);
            portfolioValue = lumpsumPortfolio + sipContribution;
            data.push({ portfolioValue: portfolioValue, time: i });
            portfolioInvestment = portfolioValue
        }
        if (data.length > 0 && data[data.length - 1].portfolioValue < 0)
            data.push({ portfolioValue: 0, time: 1 });
        // months === 0 (all horizon inputs cleared to 0) leaves data empty; seed so callers'
        // data[data.length - 1] access can't throw and blank the page.
        if (data.length === 0)
            data.push({ portfolioValue: lumpsumAmount, time: 0 });


        return data;
    }


    static portfolioAndWaitingPeriodBeforeWithdrawalCalculation({ investmentPeriod, sipAmount, expectedReturnRate, lumpsumAmount, waitingPeriodBeforeWithdrawal }: { investmentPeriod: number, sipAmount: number, expectedReturnRate: number, lumpsumAmount: number, waitingPeriodBeforeWithdrawal: number }) {
        let data: { portfolioValue: number, time: number }[] = [];
        for (let i = 1; i <= investmentPeriod; i++) {
            var maturityAmountForSIP = sipFormula(sipAmount, 0, expectedReturnRate, i);
            var maturityAmountForLumpsum = lumpsumFormula(lumpsumAmount, expectedReturnRate, i)
            data.push({ portfolioValue: maturityAmountForSIP + maturityAmountForLumpsum, time: i, });
        }
        // waiting period
        var waitingPeriodDuration = investmentPeriod + waitingPeriodBeforeWithdrawal
        for (let i = investmentPeriod; i < waitingPeriodDuration; i++) {
            // investmentPeriod === 0 (cleared) leaves the accumulation loop empty, so data[-1] is
            // undefined -> TypeError -> white page. Start the waiting phase from the lumpsum instead.
            var base = data.length > 0 ? data[data.length - 1].portfolioValue : lumpsumAmount;
            var value = base * (1 + (expectedReturnRate / 100))
            data.push({ portfolioValue: value, time: data.length + 1, });
        }
        // investmentPeriod === 0 and no waiting period leaves data empty; seed so callers can't throw.
        if (data.length === 0)
            data.push({ portfolioValue: lumpsumAmount, time: 0 });
        return data;
    }

    static regularIncomeCalculationForSWP({ sipAmount, lumpsumAmount, investmentPeriod, expectedReturnRate, waitingPeriodBeforeWithdrawal, monthlyWithdrawal, expectedReturnValue, depleteTime, }:
        { sipAmount: number, lumpsumAmount: number, investmentPeriod: number, expectedReturnRate: number, waitingPeriodBeforeWithdrawal: number, withdrawalYears: number, monthlyWithdrawal: number, expectedReturnValue: number, depleteTime: number | undefined, }) {
        let data: { portfolioValue: number, time: number }[] = [];

        if ((((investmentPeriod + waitingPeriodBeforeWithdrawal) * 12) + (depleteTime != undefined ? depleteTime : 0)) <= 24) {
            let months = ((investmentPeriod + waitingPeriodBeforeWithdrawal) * 12);


            data = this.monthlyInvestmentPortfolioCalculation({ months, expectedReturnRate, sipAmount, lumpsumAmount })

            var portfolioAmount = data[data.length - 1].portfolioValue ?? 0;
            var initValue = {
                corpusAmount: data[data.length - 1].portfolioValue,
                swp: monthlyWithdrawal,
                withdrawalRate: expectedReturnValue,
            }
            var item: { status: string, value: number | undefined } = this.getDepleteTime(initValue);

            if (item.status == 'For Life' || monthlyWithdrawal > data[data.length - 1].portfolioValue) {
                return data
            } else {
                while (portfolioAmount > 0) {
                    let portfolioValue = ((portfolioAmount - (monthlyWithdrawal)) * (1 + expectedReturnValue / 1200));
                    portfolioValue = portfolioValue > 0 ? portfolioValue : 0;
                    data.push({ portfolioValue: portfolioValue, time: data.length + 1 });
                    portfolioAmount = portfolioValue;
                }

            }

        } else {
            // investment growth
            data = this.portfolioAndWaitingPeriodBeforeWithdrawalCalculation({
                investmentPeriod,
                sipAmount,
                expectedReturnRate,
                lumpsumAmount,
                waitingPeriodBeforeWithdrawal

            })
            var initValue = {
                corpusAmount: data[data.length - 1].portfolioValue,
                swp: monthlyWithdrawal,
                withdrawalRate: expectedReturnValue,
            }

            var item: { status: string, value: number | undefined } = this.getDepleteTime(initValue);
            if (item.status == 'For Life' || monthlyWithdrawal > data[data.length - 1].portfolioValue) {
                return data;
            }
            else {

                let totalInvestment = data[data.length - 1].portfolioValue;
                let duration = item.value ?? 0
                let leftBalance = 0;
                if (totalInvestment >= 100 &&
                    monthlyWithdrawal >= 100 &&
                    expectedReturnValue >= 1 &&
                    duration >= 1) {
                    for (var j = 1; j <= duration; j++) {
                        var principalAmount = (j == 1 ? (totalInvestment - monthlyWithdrawal) : leftBalance);
                        var maturityAmountPerMonth: number = principalAmount * (1 + expectedReturnValue / (100 * 12));
                        leftBalance = (maturityAmountPerMonth - monthlyWithdrawal);
                        if (duration >= 24 && leftBalance > 0) {
                            if (j % 12 == 0) {
                                maturityAmountPerMonth = maturityAmountPerMonth > 0 ? maturityAmountPerMonth : 0;

                                data.push({ portfolioValue: maturityAmountPerMonth, time: data.length + 1, });
                            }
                        } else {
                            if (leftBalance < 0) {
                                data.push({ portfolioValue: 0, time: data.length + 1, });
                                break;
                            }
                        }
                    }
                }
                else {
                    data.push({ portfolioValue: 0, time: 0, });
                }
                return data;
            }
        }
        return data;
    }

    static getDepleteTime({ corpusAmount, swp, withdrawalRate }: { corpusAmount: number, swp: number, withdrawalRate: number }) {
        let currentAmount = corpusAmount;
        let months = 0;
        let futureValue = 0;

        while (currentAmount > 0) {
            futureValue = (currentAmount - swp) * (1 + withdrawalRate / 1200);

            // >= (not >) so swp === monthly gain — including swp/rate both 0 from cleared inputs —
            // terminates as "For Life" instead of looping forever and freezing the tab.
            if (futureValue >= currentAmount) {
                return { status: 'For Life', value: undefined };
            }

            currentAmount = futureValue;
            months++;
        }

        if (months < 12) {
            return { status: `${months - 1} - ${months} months`, value: months };
        }

        return { status: getYearMonth(months), value: months };
    }

    static getPortFolioValue(
        { SIPAmount, lumpsumAmount, investmentPeriod, expectedReturnRate }:
            { SIPAmount: number, lumpsumAmount: number, investmentPeriod: number, expectedReturnRate: number }
    ) {
        let futureValue = 0;
        if (SIPAmount !== 0) {
            futureValue = sipFormula(SIPAmount, 0, expectedReturnRate, investmentPeriod);

        }
        if (lumpsumAmount !== 0) {
            futureValue += lumpsumFormula(lumpsumAmount, expectedReturnRate, investmentPeriod)
        }
        return futureValue
    }

    static calculateInvestmentValue({ expectedReturnRate, corpusAtEnd, waitingPeriodYears }: { expectedReturnRate: number, corpusAtEnd: number, waitingPeriodYears: number }) {
        let result;
        if (waitingPeriodYears > 0) {
            const futureValue = lumpsumFormula(corpusAtEnd, expectedReturnRate, waitingPeriodYears)
            result = futureValue;
        } else {
            result = corpusAtEnd;
        }
        return result;
    }

    static calculateMonthlyWithdrawal({ corpusBeforeWithdrawal, withdrawalYears, returnExpected }: { corpusBeforeWithdrawal: number, withdrawalYears: number, returnExpected: number }) {
        // A cleared input coerces to 0 in MWeb's CalculatorInput. withdrawalYears === 0 (or an empty
        // corpus) makes the denominator 0 -> Infinity -> currency() recurses infinitely -> white page.
        if (!(withdrawalYears > 0) || !(corpusBeforeWithdrawal > 0)) return 0;
        var rate = (1 + returnExpected / (1200));
        var growth = Math.pow(rate, (withdrawalYears * 12));
        // returnExpected === 0 -> rate === 1 -> growth === 1 -> 0/0 (NaN); fall back to an even split.
        if (growth === 1) return corpusBeforeWithdrawal / (withdrawalYears * 12);
        var withdrawalAmount = corpusBeforeWithdrawal * growth * (rate - 1) / ((rate) * (growth - 1))
        withdrawalAmount = withdrawalAmount - 0.01;
        return withdrawalAmount;
    }

}

var ppfReturnsRate: { [key: string]: number } = {
    "1980": 8,
    "1981": 8.5,
    "1982": 8.5,
    "1983": 9,
    "1984": 9.5,
    "1985": 10,
    "1986": 12,
    "1987": 12,
    "1988": 12,
    "1989": 12,
    "1990": 12,
    "1991": 12,
    "1992": 12,
    "1993": 12,
    "1994": 12,
    "1995": 12,
    "1996": 12,
    "1997": 12,
    "1998": 12,
    "1999": 12,
    "2000": 11,
    "2001": 9.5,
    "2002": 9,
    "2003": 8,
    "2004": 8,
    "2005": 8,
    "2006": 8,
    "2007": 8,
    "2008": 8,
    "2009": 8,
    "2010": 8,
    "2011": 8.6,
    "2012": 8.8,
    "2013": 8.7,
    "2014": 8.7,
    "2015": 8.7,
    "2016": 8.1,
    "2017": 8.7,
    "2018": 8.7,
    "2019": 8.7

    // more complex structure than this
}



